// Angular
import {
  Component,
  Inject,
  LOCALE_ID,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterContentInit,
  AfterViewInit,
} from "@angular/core";
import { formatNumber, formatDate } from "@angular/common";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { map, Observable, Subscription } from "rxjs";
// Kendo UI
import {
  DataStateChangeEvent,
  GridDataResult,
  GridComponent,
  PageChangeEvent,
} from "@progress/kendo-angular-grid";
import {
  groupBy,
  GroupResult,
  State,
  SortDescriptor,
  AggregateDescriptor,
  GroupDescriptor,
  process,
  aggregateBy,
  AggregateResult,
} from "@progress/kendo-data-query";
import {
  Circle,
  geometry,
  Group,
  Path,
  ShapeOptions,
  Text as KendoText,
} from "@progress/kendo-drawing";
import {
  WindowRef,
  WindowService,
  WindowCloseResult,
} from "@progress/kendo-angular-dialog";
import { Circle as CircleShape, Point } from "@progress/kendo-drawing/geometry";
// Custom
import { ValueAxisModel } from "../shared/models/value-axis.model";
import { CategoryAxisModel } from "../shared/models/category-axis.model";
import { ReportService } from "../shared/services/report.service";
import { FilterTemplateRequestModel } from "../shared/models/filter-templates.request.model";
import { UserService } from "src/app/admin/user/shared/services/user.service";
import { ReportCommonService } from "../shared/services/report-common.service";
import { DetailsViewChartDataRequest } from "../shared/models/chart-data.request.model";
import { FiltersComponent } from "../filters/filters.component";
import {
  LobbyDetailViewGridRequest,
  LobbyDetailViewExportRequest,
} from "../shared/models/grid-data.model";
import { GetUserPermissionList } from "./../../state/index";
// HTTP Response models
import {
  LobbyDetailViewHeaderDataResponseModel,
  LobbyDetailViewTrafficAndWaitByMonthResponseModel,
  LobbyDetailViewTrafficAndWaitByWeekResponseModel,
  LobbyDetailViewTrafficAndWaitByDayResponseModel,
  LobbyDetailViewTrafficAndWaitByHourResponseModel,
  LobbyDetailViewTrafficAndWaitByLocationResponseModel,
  LobbyDetailViewProductsAndServicesByLocationResponseModel,
  LobbyDetailViewAvgAssistTimeByLocationResponseModel,
  LobbyDetailViewProductsAndServicesByEmployeeResponseModel,
  LobbyDetailViewAvgAssistTimeByEmployeeResponseModel,
  LobbyDetailViewProductsAndServicesProvidedResponseModel,
  LobbyDetailViewAvgAssistTimeByProductOrServiceResponseModel,
  LobbyDetailViewAllChartsDataResponseModel,
  SignInOutDetailResponseModel,
} from "../shared/models/lobby-data-view.response.model";
// Other
import _ from "lodash";
import {
  LegendItemVisualArgs,
  SeriesVisualArgs,
  AxisLabelVisualArgs,
  SeriesLabelsContentArgs,
  SeriesLabelsVisualArgs,
} from "@progress/kendo-angular-charts";
// Unreferenced - may remove later
//import { DESCRIPTOR_OVERLOADS } from 'node_modules/tslint/lib/rules/completedDocsRule';
//import { timer } from 'rxjs';
import { SortInfo } from "../../shared/models/queryparams/sortinfo.model";
import { PageInfo } from "../../admin/user/shared/models/pageInfoModel";
import { FilterTemplateResponseModel } from "../shared/models/filter-template.response.model";
import { getACLicenseStatus } from "src/app/state";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { DetailView } from "src/app/shared/enums/detailView.enum";
import { FiltersOptionsModel } from "../shared/models/filter-options-model";
//state
import { getLoggedInUserInfo } from "src/app/state";

@Component({
  selector: "app-lobby-detail-view",
  templateUrl: "./lobby-detail-view.component.html",
  styleUrls: ["./lobby-detail-view.component.scss"],
})
export class LobbyDetailViewComponent
  implements OnInit, OnDestroy, AfterViewInit, AfterContentInit
{
  isACLicenseEnabled$: Observable<boolean> = new Observable<boolean>();
  public loading = 0;
  public queryLookbackYears: number = 0;
  public detailViewForm!: FormGroup;
  public pageInitialized = true;
  private windowRef?: WindowRef;
  public lastRefreshedDate: Date = new Date();
  public lastRefreshedString: string = "";
  public lastUpdate: Date = new Date();
  public lastRefreshed: string = "";
  public eagerLoad = true;
  public loadingTimer: Subscription = new Subscription();
  public currentLoadingPromptState: number = 0;
  public loadingPrompt: string = "";
  public initialReportExecutionComplete: boolean = false;
  interval: any;
  applyClickedSubscription: Subscription = new Subscription();
  scrollTopSubscription: Subscription = new Subscription();
  applyEventSubscription: Subscription = new Subscription();
  public defaultSort: SortDescriptor[] = [{ field: "addedTime", dir: "desc" }];
  public sort: SortDescriptor[] = [{ field: "addedTime", dir: "desc" }];
  public gridData: GridDataResult = { data: [], total: 0 };
  public pageSize = 20;
  public skip = 0;
  public detailViewId: number = DetailView["Lobby_Activity"];
  public loadSeachWithGrid: boolean = false;
  public signInOutDetailGridDataView: any | SignInOutDetailResponseModel[];
  public hasViewSignInOutReportPermission: boolean = false;
  public filterText: string = "";
  public aggregates: AggregateDescriptor[] = [
    { field: "employeeName", aggregate: "count" },
    { field: "idleTimeInSeconds", aggregate: "sum" },
    { field: "interactionTimeInSeconds", aggregate: "sum" },
    { field: "signedInTimeInSeconds", aggregate: "sum" },
    { field: "signedOutTimeInSeconds", aggregate: "sum" },
  ];

  public group: GroupDescriptor[] = [
    { field: "locationName", aggregates: this.aggregates },
    { field: "employeeName", aggregates: this.aggregates },
  ];

  // Specific to Employee View and Location Comparison Views Avg Assist Times Charts
  public seriesCenters: Point[] = [];
  public counter = 0;
  public series: GroupResult[] = [];
  public filterMonthForMonthChart: LobbyDetailViewTrafficAndWaitByMonthResponseModel[] =
    [];
  @ViewChild("grid") grid?: GridComponent;

  /**
   * The minimum value that the time axis should have at the top/range-end.
   */
  private static readonly MINIMUM_RANGE_END = 5 * 60;

  //To minimize the category axis labels getting overlapped issue in some instances, the label will be taken to a new line after 15 caracters
  categoryLabelMultiline: any = {
    content: function (e: { value: string }) {
      const rawLabel: string = e.value;
      const wordBreakLimit = 15;
      if (rawLabel.length > wordBreakLimit) {
        const parts: Array<string> = [];
        var y = 0;
        for (let x = 0; x < Math.ceil(rawLabel.length / wordBreakLimit); x++) {
          const part = rawLabel.substring(y, y + wordBreakLimit);
          y = y + wordBreakLimit;
          parts.push(part);
        }
        const formattedLabel = parts.join("\n");
        return formattedLabel;
      } else {
        return e.value;
      }
    },
    rotation: "auto",
  };

  // To define the line stroke colors for location, employee charts
  seriesColors = {
    Products: "#007BDB",
    Services: "#54BBBA",
    Other: "#404756",
  };

  isReportRunning: boolean = false;
  isLocationDataAvailable: boolean = true;
  public showClearButton: boolean = true;
  public loadingDataText: string = "";
  public preferedTzOffset: number = 0;
  public preferedTzCode: string = "";
  public FiltersPopupOpened = false;

  constructor(
    public reportService: ReportService,
    public fb: FormBuilder,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    public commonData: ReportCommonService,
    private windowService: WindowService,
    @Inject(LOCALE_ID) public locale: string,
    private translateService: TranslateService,
    private store: Store<State>
  ) {
    // Specific to Employee View and Location Comparison Views Avg Assist Times Charts
    this.visual = this.visual.bind(this);
    this.seriesVisuals = this.seriesVisuals.bind(this);
    this.legendVisuals = this.legendVisuals.bind(this);
    this.yaxisVisual = this.yaxisVisual.bind(this);
  }

  ngOnInit() {
    this.translateService.get("_Report_Loading_Data_Text_").subscribe((res) => {
      this.loadingDataText = res;
    });
    this.isACLicenseEnabled$ = this.store.select(getACLicenseStatus);
    this.pageInitialized = true;
    this.initialReportExecutionComplete = false;
    this.queryLookbackYears = this.reportService.getChartQueryLookbackYears();

    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (allUserPermissions) {
        this.hasViewSignInOutReportPermission =
          allUserPermissions?.includes(91);
      }
    });

    this.commonData.applyClicked.subscribe((s: number) => {
      if (s == this.detailViewId) {
        this.isLocationDataAvailable = true;
        this.resetGridOptions();
        this.refreshSelectedTemplateDropdown();
        this.runReport();
        this.commonData.applyEventSubscribed = true;
      }
    });
  }
  ngOnDestroy(): void {
    if (this.windowRef != null) {
      this.windowRef.close();
    }
    this.FiltersPopupOpened = false;
    if (this.commonData.applyEventSubscribed == true) {
      this.commonData.applyClicked.observers = [];
      // this.commonData.applyClicked.unsubscribe();
      // this.scrollTopSubscription.unsubscribe();
      this.commonData.applyEventSubscribed = false;
    }
  }

  ngAfterViewInit() {
    this.commonData.applyEventSubscribed = false;
    this.commonData.firstCategoryIndex = 0;
    this.commonData.lastCategoryIndex = 10;
    window.scrollTo(0, 0);
  }

  ngAfterContentInit() {
    this.generateDetailViewForm();
    this.commonData.reportEndDate = new Date();
    this.commonData.reportEndDate.setDate(
      this.commonData.reportEndDate.getDate()
    );
    this.commonData.reportStartDate = new Date(
      this.commonData.reportEndDate.valueOf()
    );
    this.commonData.reportStartDate.setDate(
      this.commonData.reportStartDate.getDate() - 7
    );
    this.commonData.minReportDate = new Date("1/1/1900");
    this.commonData.maxReportDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.detailViewForm.get("from")?.setValue(this.commonData.reportStartDate);
    this.detailViewForm.get("to")?.setValue(this.commonData.reportEndDate);
    this.getAllFilterTemplates();
    //this.getClientOrigDate();
  }

  isDateDisabled(date: Date): boolean {
    return (
      date < this.commonData.minReportDate ||
      date > this.commonData.maxReportDate
    );
  }

  public optionsWindowClosingEvent(closingType: boolean): void {}

  public getClientOrigDate() {
    this.reportService.getClientOrigDate().subscribe((d) => {
      var clientOrigDate = new Date(d.origDate);
      clientOrigDate.setFullYear(
        clientOrigDate.getFullYear() - this.queryLookbackYears
      );
      clientOrigDate.setHours(0);
      clientOrigDate.setMinutes(0);
      clientOrigDate.setSeconds(0);
      clientOrigDate.setMilliseconds(0);

      this.commonData.maxReportDate = new Date(new Date().setHours(0, 0, 0, 0));

      // Calc two years prior to yesterday
      var testDate1 = new Date(this.commonData.reportEndDate.valueOf());
      testDate1.setHours(0);
      testDate1.setMinutes(0);
      testDate1.setSeconds(0);
      testDate1.setMilliseconds(0);
      testDate1.setFullYear(testDate1.getFullYear() - this.queryLookbackYears);

      // Min date is the greater of testDate1 or clientOrigDate
      if (testDate1 < clientOrigDate) {
        this.commonData.minReportDate = clientOrigDate;
      } else {
        this.commonData.minReportDate = testDate1;
      }

      this.detailViewForm.get("to")?.setValue(this.commonData.reportEndDate);
      this.detailViewForm
        .get("from")
        ?.setValue(this.commonData.reportStartDate);
      this.getAllFilterTemplates();
    });
  }

  public setActiveTemplateOnUI(s: string) {
    this.detailViewForm.get("activeFilterTemplate")?.setValue(s);
  }

  public refreshSelectedTemplateDropdown() {
    this.setActiveTemplateOnUI(this.commonData.currentTemplate.templateName);
    const currentViewValue = this.detailViewForm.get("selectedViewDropdown")?.value;
    if (!currentViewValue || currentViewValue.length === 0) {
      var vName = this.commonData.savedViewName && this.commonData.savedViewName.length > 0
        ? this.commonData.savedViewName
        : this.getDefaultViewNameFromCurrentTemplate();
      this.setInitialViewOnUI(vName);
    }
  }

  public activeTemplateChanged(e: string) {
    var s = this.detailViewForm.get("activeFilterTemplate")?.value;
    this.commonData.SetActiveTemplate(s);
    var vName = this.getDefaultViewNameFromCurrentTemplate();
    this.setInitialViewOnUI(vName);
    this.commonData.ConvertCurrentTemplateToOptions(this.detailViewId);
    this.commonData.trafficAndWaitViewDataLoaded = false;
    this.commonData.locationComparisonViewDataLoaded = false;
    this.commonData.productsAndServicesViewDataLoaded = false;
    this.commonData.employeeViewDataLoaded = false;
    this.commonData.headerDataLoaded = false;
    this.resetGridOptions();
    this.runReport();
  }

  public selectedViewChanged(v: string) {
    // if (
    //   (this.getCurrentViewName() === 'Traffic & Wait Time' && this.commonData.trafficAndWaitViewDataLoaded == false) ||
    //   (this.getCurrentViewName() === 'Location Comparison' && this.commonData.locationComparisonViewDataLoaded == false) ||
    //   (this.getCurrentViewName() === 'Employee' && this.commonData.employeeViewDataLoaded == false) ||
    //   (this.getCurrentViewName() === 'Products & Services' && this.commonData.productsAndServicesViewDataLoaded == false)
    // ) {
    //   this.doChartLoads();
    // }

    // load search field
    if (v == "Details") this.loadSeachWithGrid = true;
    else this.loadSeachWithGrid = false;
    this.filterText = "";
  }

  public getAllFilterTemplates() {
    let templateRequest = new FilterTemplateRequestModel();
    templateRequest.TemplateId = 0;
    templateRequest.DetailViewId = this.detailViewId;
    this.commonData.templates.length = 0;
    this.commonData.originalTemplates.length = 0;
    this.reportService
      .getDetailsViewTemplates(templateRequest)
      .subscribe((templates) => {
        this.commonData.templates = [];
        this.commonData.originalTemplates = [];
        for (var template of templates) {
          this.commonData.AddTemplate(
            new FilterTemplateResponseModel(template)
          );
        }
        const t: FilterTemplateResponseModel | undefined =
          this.commonData.GetDefaultTemplate(this.commonData.templates);

        if (!t) {
          throw Error("this.commonData.GetDefaultTemplate returned undefined!");
        }
        this.commonData.currentTemplate = t;
        this.setActiveTemplateOnUI(t.templateName);
        this.getFilterOptions();
      });
  }

  public fromDateChange() {
    this.resetGridOptions();
    this.commonData.reportStartDate = this.detailViewForm.get("from")?.value;
    if (this.commonData.reportStartDate > this.commonData.reportEndDate) {
      this.commonData.reportStartDate = this.commonData.reportEndDate;
      this.detailViewForm
        .get("from")
        ?.setValue(this.commonData.reportStartDate);
    }
  }

  public toDateChange() {
    this.resetGridOptions();
    this.commonData.reportEndDate = this.detailViewForm.get("to")?.value;
    if (this.commonData.reportEndDate < this.commonData.reportStartDate) {
      this.commonData.reportEndDate = this.commonData.reportStartDate;
      this.detailViewForm.get("to")?.setValue(this.commonData.reportEndDate);
    }
  }

  public getFilterOptions() {
    this.reportService.getDetailsViewFilterOptions(1).subscribe((options) => {
      this.mapOptions(options);
      var vName = this.getDefaultViewNameFromCurrentTemplate();
      this.setInitialViewOnUI(vName);
      this.commonData.trafficAndWaitViewDataLoaded = false;
      this.commonData.locationComparisonViewDataLoaded = false;
      this.commonData.productsAndServicesViewDataLoaded = false;
      this.commonData.employeeViewDataLoaded = false;
      this.commonData.headerDataLoaded = false;
      this.runReport();
    });
  }

  public setInitialViewOnUI(s: string) {
    this.detailViewForm.get("selectedViewDropdown")?.setValue(s);
  }

  public getDefaultViewNameFromCurrentTemplate() {
    return this.translateService.instant(
      this.commonData.currentTemplate.activeFilters.defaultViews[0]
        .viewLocalizedName ??
        this.commonData.currentTemplate.activeFilters.defaultViews[0].viewName
    );
  }

  public getCurrentViewName() {
    return this.detailViewForm.get("selectedViewDropdown")?.value;
  }

  public mapOptions(options: FiltersOptionsModel) {
    this.commonData.options = options;
    this.commonData.options.filteredServices = this.commonData.options.services;
    this.commonData.options.filteredAssistedBys =
      this.commonData.options.assistedBy;
    this.commonData.ConvertCurrentTemplateToOptions(this.detailViewId);
  }

  public generateDetailViewForm() {
    this.detailViewForm = this.fb.group({
      to: [null, [Validators.required]],
      from: [null, [Validators.required]],
      activeFilterTemplate: [null, [Validators.required]],
      selectedViewDropdown: [null, []],
    });
  }

  public goToFilterOptions() {
    this.filterText = "";
    if (this.loading == 0) {
      if (this.commonData.applyEventSubscribed == false) {
        this.scrollTopSubscription = this.commonData.scrollTop.subscribe(() => {
          window.scrollTo(0, 0);
        });
      }
      // Save dates
      this.commonData.reportStartDate = this.detailViewForm.get("from")?.value;
      this.commonData.reportEndDate = this.detailViewForm.get("to")?.value;
      this.commonData.savedViewName = this.detailViewForm.get(
        "selectedViewDropdown"
      )?.value;
      this.windowRef = this.windowService.open({
        title: this.translateService.instant("_General_FilterOption_Text_"),
        content: FiltersComponent,
        width: 800,
        height: 950,
        top: 20,
        left: 150,
      });
      this.FiltersPopupOpened = true;
      this.windowRef.result.subscribe((result) => {
        if (result instanceof WindowCloseResult) {
          this.FiltersPopupOpened = false;
        }
      });
      this.windowRef.content.instance.detailViewId = this.detailViewId;
    }
  }

  public incrementLoading() {
    this.loading++;
    this.detailViewForm.disable();
  }

  public decrementLoading() {
    if (this.loading > 0) {
      this.loading--;
    }
    if (this.loading == 0) {
      this.detailViewForm.enable();
    }
  }

  public nextLoadingPrompt() {
    this.loadingPrompt = this.loadingPrompt + ".";
  }

  public doChartLoads() {
    this.incrementLoading();
    var chartHeaderDataRequest = new DetailsViewChartDataRequest(
      this.commonData.currentTemplate,
      this.commonData.reportStartDate,
      this.commonData.reportEndDate
    );
    this.currentLoadingPromptState = 0;
    this.loadingPrompt = this.loadingDataText;
    this.commonData.runReportExecuted = false;
    this.interval = setInterval(() => {
      if (this.commonData.runReportExecuted) {
        clearInterval(this.interval);
        this.initialReportExecutionComplete = true;
        this.decrementLoading();
      } else {
        this.nextLoadingPrompt();
        if (this.currentLoadingPromptState > 10) {
          this.currentLoadingPromptState = 0;
          this.loadingPrompt = this.loadingDataText;
        } else {
          this.currentLoadingPromptState++;
        }
      }
    }, 500);

    if (this.commonData.options.locations.length == 0 && !this.commonData.currentTemplate.allLocations) {
      this.commonData.runReportExecuted = true;
      this.ConvertLocalTimeToUtc();
      this.lastRefreshedString = formatDate(
        this.lastRefreshedDate,
        "MMMM dd, yyyy h:mm:ss a",
        this.locale
      );

      this.isLocationDataAvailable = false;
      this.mapAllChartData(new LobbyDetailViewAllChartsDataResponseModel());
      this.FormatRefreshedDate().subscribe((refreshedString: string) => {
        this.lastRefreshed = refreshedString;
      });
    } else {
      this.isLocationDataAvailable = true;
      this.reportService
        .getDetailsViewAllData(chartHeaderDataRequest)
        .subscribe(
          (responseData) => {
            this.mapAllChartData(responseData);

            var mappedValues = this.mapSignInOutDetailsGridData(
              responseData.staffSignInOutDetails.data
            );
            this.signInOutDetailGridDataView = mappedValues;

            this.commonData.runReportExecuted = true;
            this.ConvertLocalTimeToUtc();
            this.lastRefreshedString = formatDate(
              this.lastRefreshedDate,
              "MMMM dd, yyyy h:mm:ss a",
              this.locale
            );
            this.FormatRefreshedDate().subscribe((refreshedString: string) => {
              this.lastRefreshed = refreshedString;
            });
          },
          (error) => {
            console.error(error);
          },
          () => {
            this.isReportRunning = false;
            this.decrementLoading();
          }
        );
    }
  }

  // **************************************************************************************************
  // Sign In Out Details Grid
  // **************************************************************************************************
  public mapSignInOutDetailsGridData(_data: SignInOutDetailResponseModel[]) {
    if (_data == null || _data[0].locationName == "") return [];

    const dateConfig: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };
    const timeConfig: Intl.DateTimeFormatOptions = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };

    return _data.map((o) => {
      const signInDate = new Date(o.staffSignInDate);
      const signOutDate = new Date(o.staffSignOutDate);

      return {
        ...o,
        staffSignInDate: signInDate.toLocaleDateString("en-US", dateConfig),
        staffSignInTime: signInDate.toLocaleTimeString("en-US", timeConfig),
        signedInTimeInSeconds: Math.floor(
          (signOutDate.getTime() - signInDate.getTime()) / 1000
        ),
        staffSignOutTime: isNaN(signOutDate.getDate())
          ? " - "
          : signOutDate.toLocaleTimeString("en-US", timeConfig) +
            (signInDate.getDate() === signOutDate.getDate()
              ? ""
              : " (" +
                signOutDate.toLocaleDateString("en-US", dateConfig) +
                ")"),
        idleTime: this.formatIdleTime(o.idleTimeInSeconds, this.locale),
        idleTimeInSeconds: o.idleTimeInSeconds,
        interactionTime: this.formatIdleTime(
          o.interactionTimeInSeconds,
          this.locale
        ),
        signedOutTime: this.formatIdleTime(
          o.signedOutTimeInSeconds,
          this.locale
        ),
        productivityPercentageStr: o.productivityPercentage.toFixed(2) + "%",
        signOutReason: isNaN(signOutDate.getDate())
          ? ""
          : o.signOutReason?.trim()
          ? o.signOutReason.includes("Signed-out by")
            ? o.signOutReason.replace(
                "Signed-out by",
                this.translateService.instant(
                  "_Report_SignInOut_SignedOutBy_Text_"
                )
              )
            : o.signOutReason
          : this.translateService.instant("_Report_SignInOut_Reason_Text_"),
      };
    });
  }

  public formatIdleTime(seconds: number, locale: string = this.locale): string {
    var timeRemains = Math.floor(seconds);
    const hours = Math.floor(timeRemains / (60 * 60));
    timeRemains %= 60 * 60;
    const minutes = Math.floor(timeRemains / 60);
    timeRemains %= 60;
    const secondsR = Math.floor(timeRemains);

    return (
      formatNumber(hours, locale, "1.0-0") +
      ":" +
      formatNumber(minutes, locale, "2.0-0") +
      ":" +
      formatNumber(secondsR, locale, "2.0-0")
    );
  }

  public getDistinctCount(field: string, group: any[]): number {
    const values = new Set<string | number>();

    group.forEach((item) => {
      const items = item.items ?? [item]; // works for both grouped and flat
      items.forEach((entry: any) => values.add(entry[field]));
    });

    return values.size;
  }

  public calculatePercentage(assistTime: number, signedInTime: number): string {
    if (!signedInTime || signedInTime === 0) return "0.00%";

    const percentage = (assistTime / signedInTime) * 100;
    return percentage.toFixed(2) + "%";
  }

  public loadGridData(searchTextGrid: string | null) {
    var gridDataRequest = new LobbyDetailViewGridRequest(
      this.commonData.currentTemplate,
      this.commonData.reportStartDate,
      this.commonData.reportEndDate,
      this.getPageInfo(),
      this.getSortInfo(),
      searchTextGrid
    );

    this.reportService
      .getLobbyDetailViewGrid(gridDataRequest)
      .subscribe((responseData) => {
        this.isReportRunning = false;
        this.gridData = {
          data: responseData.data,
          total: responseData.totalRowCount,
        };
        this.gridData.data.forEach((entry) => {
          if (Array.isArray(entry.servicesProvided)) {
            entry.servicesProvided.forEach((service: any) => {
              if (service.requested === "Yes") {
                service.requested = this.translateService.instant(
                  "_General_Action_Label_Yes_Text_"
                );
              } else if (service.requested === "No") {
                service.requested = this.translateService.instant(
                  "_General_Action_Label_No_Text_"
                );
              }
            });
          }
        });
        //this.detailViewForm.enable();
        this.collapseAllRows();
      });
  }

  public runReportDirect() {
    this.filterText = "";
    this.runReport();
  }

  public runReport(loadCharts: boolean = true, isSearchOn: boolean = false) {
    this.isReportRunning = true;
    this.loading = 0;
    this.commonData.reportStartDate =
      this.detailViewForm.controls["from"].value;
    this.commonData.reportEndDate = this.detailViewForm.controls["to"].value;
    this.commonData.headerDataLoaded = false;
    this.commonData.trafficAndWaitViewDataLoaded = false;
    this.commonData.locationComparisonViewDataLoaded = false;
    this.commonData.productsAndServicesViewDataLoaded = false;
    this.commonData.employeeViewDataLoaded = false;
    if (loadCharts) {
      this.doChartLoads();
    }

    if (isSearchOn) {
      this.loadGridData(this.filterText);
    } else {
      this.loadGridData(null);
    }
  }

  private FormatRefreshedDate(): Observable<string> {
    const StartDate = formatDate(
      this.commonData.reportStartDate,
      "MMMM dd, yyyy",
      this.locale
    );
    const EndDate = formatDate(
      this.commonData.reportEndDate,
      "MMMM dd, yyyy",
      this.locale
    );

    return this.userService.getLoggedInUserInfo().pipe(
      map((loggedInUserInfo) => {
        this.lastUpdate = new Date();
        this.preferedTzOffset = loggedInUserInfo.prefferedTimeZone.utcOffset;
        this.preferedTzCode = loggedInUserInfo.prefferedTimeZone.tzCode;
        const lastUpdateString = `${StartDate} - ${EndDate}. ${this.translateService.instant(
          "_Report_Last_Refreshed_Ts_Text_"
        )}`;
        return lastUpdateString;
      })
    );
  }
  private ConvertLocalTimeToUtc() {
    var refreshDate = new Date();
    const utcTime = {
      year: refreshDate.getUTCFullYear(),
      month: refreshDate.getUTCMonth(),
      day: refreshDate.getUTCDate(),
      hours: refreshDate.getUTCHours(),
      minutes: refreshDate.getUTCMinutes(),
      seconds: refreshDate.getUTCSeconds(),
      milliseconds: refreshDate.getUTCMilliseconds(),
    };

    this.lastRefreshedDate = new Date(
      utcTime.year,
      utcTime.month,
      utcTime.day,
      utcTime.hours,
      utcTime.minutes,
      utcTime.seconds,
      utcTime.milliseconds
    );
  }

  public mapAllChartData(_data: LobbyDetailViewAllChartsDataResponseModel) {
    if (!this.commonData.lobbyReportHeaderData) {
      this.commonData.lobbyReportHeaderData =
        new LobbyDetailViewHeaderDataResponseModel();
    }
    if (_data.headerData.length == 0) {
      this.commonData.lobbyReportHeaderData =
        new LobbyDetailViewHeaderDataResponseModel();
      this.commonData.lobbyReportHeaderData.avgWaitTimeFormatted =
        "0:" + formatNumber(0, this.locale, "2.0-0");
      this.commonData.lobbyReportHeaderData.avgAssistTimeFormatted =
        "0:" + formatNumber(0, this.locale, "2.0-0");
    } else {
      this.commonData.lobbyReportHeaderData = _data.headerData[0];
      this.commonData.lobbyReportHeaderData.avgWaitTimeFormatted =
        Math.floor(this.commonData.lobbyReportHeaderData.avgWaitTime / 60) +
        ":" +
        formatNumber(
          this.commonData.lobbyReportHeaderData.avgWaitTime % 60,
          this.locale,
          "2.0-0"
        );
      this.commonData.lobbyReportHeaderData.avgAssistTimeFormatted =
        Math.floor(this.commonData.lobbyReportHeaderData.avgAssistTime / 60) +
        ":" +
        formatNumber(
          this.commonData.lobbyReportHeaderData.avgAssistTime % 60,
          this.locale,
          "2.0-0"
        );

      this.mapAvgTrafficAndWaitByHourData(_data.trafficAndWaitDataByHour);
      this.mapAvgTrafficAndWaitByMonthData(_data.trafficAndWaitDataByMonth);
      this.mapAvgTrafficAndWaitByWeekOfMonthData(
        _data.trafficAndWaitDataByWeekOfMonth
      );
      this.mapAvgTrafficAndWaitByDayData(_data.trafficAndWaitDataByDayOfWeek);

      this.mapTrafficAndWaitByLocationData(_data.trafficAndWaitDataByLocation);
      this.mapProductsAndServicesByLocationData(
        _data.productsAndServicesDataByLocation
      );
      this.mapAvgAssistTimeByLocationData(_data.avgAssistTimeDataByLocation);

      this.mapProductsAndServicesByEmployeeData(
        _data.productsAndServicesDataByEmployee
      );
      this.mapAvgAssistTimeByEmployeeData(_data.avgAssistTimeDataByEmployee);

      this.mapProductsAndServicesProvidedData(
        _data.productsAndServicesProvided
      );
      this.mapAvgAssistTimeByProductOrServiceData(
        _data.avgAssistTimeDataByProductOrService
      );
    }
  }

  // **************************************************************************************************
  // *********************************** Chart Mappers ************************************************
  // Called by mapAllChartData
  // Each mapper creates and populates the relevant chart axes, categories arrays, chart formats,
  // and data arrays.
  // Finally the structures are loaded into series collections that are bound to the Kendo html UI
  // **************************************************************************************************
  // **************************************************************************************************

  // **************************************************************************************************
  // Traffic and Wait Time View
  // **************************************************************************************************
  public mapAvgTrafficAndWaitByWeekOfMonthData(
    _data: LobbyDetailViewTrafficAndWaitByWeekResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.avgTrafficWaitByWeekOfMonthSeriesData = new Array<any>();
      this.commonData.avgTrafficWaitByWeekOfMonthVisible = false;
      return;
    }

    // Define value axes
    var maxValueBarsObj = _data.reduce((a, b) =>
      a.avgAppointmentsCompleted + a.avgLWA + a.avgWalkinsCompleted >
      b.avgAppointmentsCompleted + b.avgLWA + b.avgWalkinsCompleted
        ? a
        : b
    );
    var maxValueBars: number =
      maxValueBarsObj.avgAppointmentsCompleted +
      maxValueBarsObj.avgLWA +
      maxValueBarsObj.avgWalkinsCompleted +
      1;
    // if (maxValueBars < this.commonData.lobbyReportHeaderData.totalRecords) {
    //   maxValueBars = this.commonData.lobbyReportHeaderData.totalRecords;
    // }
    var minValueBars = 0;
    var maxValueLineObj = _data.reduce((a, b) =>
      a.avgWaitTime > b.avgWaitTime ? a : b
    );
    var maxValueLine: number = (maxValueLineObj.avgWaitTime / 60) * 1.1;
    if (maxValueLine < 5) {
      maxValueLine = 5;
    }
    var minValueLine = 0;
    if (!this.commonData.avgTrafficWaitByWeekOfMonthValueAxis) {
      this.commonData.avgTrafficWaitByWeekOfMonthValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.avgTrafficWaitByWeekOfMonthValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    barsModel.name = "Traffic";
    barsModel.title = this.translateService.instant("_Report_Traffic_Ts_Text_");
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars * 1.1);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    this.commonData.avgTrafficWaitByWeekOfMonthValueAxis.push(barsModel);
    var lineModel = new ValueAxisModel();
    lineModel.name = "Wait Time";
    lineModel.title = this.translateService.instant(
      "_Report_Wait_Time_Minutes_Ts_Text_"
    );
    lineModel.min = minValueLine;
    //lineModel.max = Math.ceil(maxValueLine * 1.1);
    lineModel.max = Math.ceil(maxValueLine);
    //lineModel.majorUnit = Math.floor(maxValueLine / 11);
    lineModel.majorUnit = Math.ceil(maxValueLine / 10);
    lineModel.labels = {
      format: "n",
      content: function (e) {
        const minute = Math.floor(e.value);
        return minute.toString().padStart(2, "0");
      },
    };
    this.commonData.avgTrafficWaitByWeekOfMonthValueAxis.push(lineModel);
    // Define categories
    this.commonData.avgTrafficWaitByWeekOfMonthCategories = _data.map(
      (d) => d.weekNumber
    );
    this.commonData.avgTrafficWaitByWeekOfMonthCategories =
      this.commonData.avgTrafficWaitByWeekOfMonthCategories.map((c) => {
        return "Week " + c;
      });

    // Define data series'
    if (!this.commonData.avgTrafficWaitByWeekOfMonthSeriesData) {
      this.commonData.avgTrafficWaitByWeekOfMonthSeriesData = new Array<any>();
    } else {
      this.commonData.avgTrafficWaitByWeekOfMonthSeriesData.length = 0;
    }
    var apptsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant(
        "_Report_Appointments_Completed_Ts_Text_"
      ),
      color: "#007BDB",
      axis: "Traffic",
      data: _data.map((m) => m.avgAppointmentsCompleted),
    };
    var walkInsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_WalkIn_Completed_Ts_Text_"),
      color: "#00A5DB",
      axis: "Traffic",
      data: _data.map((m) => m.avgWalkinsCompleted),
    };
    var abandonsSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_General_LWA_Text_"),
      color: "#7A45A1",
      axis: "Traffic",
      data: _data.map((m) => m.avgLWA),
    };
    var waitTimeSeries = {
      type: "line",
      stack: true,
      name: this.translateService.instant("_General_Report_Wait_Time_Text_"),
      color: "#7C91BC",
      axis: "Wait Time",
      data: _data.map((m) => ({
        value: m.avgWaitTime / 60,
        ValMinutes: Math.floor(m.avgWaitTime / 60),
        ValSeconds: formatNumber(m.avgWaitTime % 60, this.locale, "2.0-0"),
      })),
    };
    this.commonData.avgTrafficWaitByWeekOfMonthSeriesData.push(
      apptsCompletedSeries,
      walkInsCompletedSeries,
      abandonsSeries,
      waitTimeSeries
    );
    // Place Bars scale on left, line scale on right
    this.commonData.avgTrafficWaitByWeekOfMonthCrossingValues = new Array(
      0,
      this.commonData.avgTrafficWaitByWeekOfMonthCategories.length + 1
    );
    this.commonData.avgTrafficWaitByWeekOfMonthVisible = true;
  }

  public mapAvgTrafficAndWaitByDayData(
    _data: LobbyDetailViewTrafficAndWaitByDayResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.avgTrafficWaitByDaySeriesData = new Array<any>();
      this.commonData.avgTrafficWaitByDayVisible = false;
      return;
    }

    // Sort data by day number
    _data.sort((a, b) => {
      return a.dayNumber - b.dayNumber;
    });

    // Define value axes
    var maxValueBarsObj = _data.reduce((a, b) =>
      a.avgAppointmentsCompleted + a.avgLWA + a.avgWalkinsCompleted >
      b.avgAppointmentsCompleted + b.avgLWA + b.avgWalkinsCompleted
        ? a
        : b
    );
    var maxValueBars: number =
      maxValueBarsObj.avgAppointmentsCompleted +
      maxValueBarsObj.avgLWA +
      maxValueBarsObj.avgWalkinsCompleted +
      1;
    // if (maxValueBars < this.commonData.lobbyReportHeaderData.totalRecords) {
    //   maxValueBars = this.commonData.lobbyReportHeaderData.totalRecords;
    // }
    var minValueBars = 0;
    var maxValueLineObj = _data.reduce((a, b) =>
      a.avgWaitTime > b.avgWaitTime ? a : b
    );
    var maxValueLine: number = (maxValueLineObj.avgWaitTime / 60) * 1.1;
    if (maxValueLine < 5) {
      maxValueLine = 5;
    }
    var minValueLine = 0;
    if (!this.commonData.avgTrafficWaitByDayValueAxis) {
      this.commonData.avgTrafficWaitByDayValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.avgTrafficWaitByDayValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    barsModel.name = "Traffic";
    barsModel.title = this.translateService.instant("_Report_Traffic_Ts_Text_");
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars * 1.1);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    this.commonData.avgTrafficWaitByDayValueAxis.push(barsModel);
    var lineModel = new ValueAxisModel();
    lineModel.name = "Wait Time";
    lineModel.title = this.translateService.instant(
      "_Report_Wait_Time_Minutes_Ts_Text_"
    );
    lineModel.min = minValueLine;
    //lineModel.max = Math.ceil(maxValueLine * 1.1);
    lineModel.max = Math.ceil(maxValueLine);
    //lineModel.majorUnit = Math.floor(maxValueLine / 11);
    lineModel.majorUnit = Math.ceil(maxValueLine / 10);
    lineModel.labels = {
      format: "n",
      content: function (e) {
        const minute = Math.floor(e.value);
        return minute.toString().padStart(2, "0");
      },
    };
    this.commonData.avgTrafficWaitByDayValueAxis.push(lineModel);
    // Define categories
    this.commonData.avgTrafficWaitByDayCategories = _data.map((d) => d.dayName);
    // Define data series'
    if (!this.commonData.avgTrafficWaitByDaySeriesData) {
      this.commonData.avgTrafficWaitByDaySeriesData = new Array<any>();
    } else {
      this.commonData.avgTrafficWaitByDaySeriesData.length = 0;
    }
    var apptsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant(
        "_Report_Appointments_Completed_Ts_Text_"
      ),
      color: "#007BDB",
      axis: "Traffic",
      data: _data.map((m) => m.avgAppointmentsCompleted),
    };
    var walkInsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_WalkIn_Completed_Ts_Text_"),
      color: "#00A5DB",
      axis: "Traffic",
      data: _data.map((m) => m.avgWalkinsCompleted),
    };
    var abandonsSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_General_LWA_Text_"),
      color: "#7A45A1",
      axis: "Traffic",
      data: _data.map((m) => m.avgLWA),
    };
    var waitTimeSeries = {
      type: "line",
      stack: true,
      name: this.translateService.instant("_General_Report_Wait_Time_Text_"),
      color: "#7C91BC",
      axis: "Wait Time",
      data: _data.map((m) => ({
        value: m.avgWaitTime / 60,
        ValMinutes: Math.floor(m.avgWaitTime / 60),
        ValSeconds: formatNumber(m.avgWaitTime % 60, this.locale, "2.0-0"),
      })),
    };
    var totalSeries = {
      type: "column",
      stack: true,
      name: "__total__",
      color: "transparent",
      axis: "Traffic",
      data: _data.map((m) => ({
        value: 0,
      })),
    };
    this.commonData.avgTrafficWaitByDaySeriesData.push(
      apptsCompletedSeries,
      walkInsCompletedSeries,
      abandonsSeries,
      waitTimeSeries,
      totalSeries
    );
    // Place Bars scale on left, line scale on right
    this.commonData.avgTrafficWaitByDayCrossingValues = new Array(
      0,
      this.commonData.avgTrafficWaitByDayCategories.length + 1
    );
    this.commonData.avgTrafficWaitByDayVisible = true;
  }

  public mapAvgTrafficAndWaitByHourData(
    _data: LobbyDetailViewTrafficAndWaitByHourResponseModel[]
  ) {
    if (_data == null || _data.length == 0) {
      this.commonData.avgTrafficWaitByHourSeriesData = new Array<any>();
      this.commonData.avgTrafficWaitByHourVisible = false;
      return;
    }
    _data = _data.filter(
      (d) =>
        d.hourNumberAsNumber >=
          this.commonData.lobbyReportHeaderData.earliestOpenHour &&
        d.hourNumberAsNumber <=
          this.commonData.lobbyReportHeaderData.latestCloseHour
    );
    // Define value axes
    var maxValueBarsObj = _data.reduce((a, b) =>
      a.avgAppointmentsCompleted + a.avgLWA + a.avgWalkinsCompleted >
      b.avgAppointmentsCompleted + b.avgLWA + b.avgWalkinsCompleted
        ? a
        : b
    );
    var maxValueBars: number =
      maxValueBarsObj.avgAppointmentsCompleted +
      maxValueBarsObj.avgLWA +
      maxValueBarsObj.avgWalkinsCompleted +
      1;
    // if (maxValueBars < this.commonData.lobbyReportHeaderData.totalRecords) {
    //   maxValueBars = this.commonData.lobbyReportHeaderData.totalRecords;
    // }
    var minValueBars = 0;
    var maxValueLineObj = _data.reduce((a, b) =>
      a.avgWaitTime > b.avgWaitTime ? a : b
    );
    var maxValueLine: number = maxValueLineObj.avgWaitTime * 1.1;
    if (maxValueLine < 5) {
      maxValueLine = 5;
    }
    var minValueLine = 0;
    if (!this.commonData.avgTrafficWaitByHourValueAxis) {
      this.commonData.avgTrafficWaitByHourValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.avgTrafficWaitByHourValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    barsModel.name = "Traffic";
    barsModel.title = this.translateService.instant("_Report_Traffic_Ts_Text_");
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars * 1.1);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    this.commonData.avgTrafficWaitByHourValueAxis.push(barsModel);
    var lineModel = new ValueAxisModel();
    lineModel.name = "Wait Time";
    lineModel.title = this.translateService.instant(
      "_Report_Wait_Time_Minutes_Ts_Text_"
    );
    lineModel.min = minValueLine;

    const tentativeMaxValueLine = Math.ceil(maxValueLine);
    if (tentativeMaxValueLine < LobbyDetailViewComponent.MINIMUM_RANGE_END) {
      lineModel.max = LobbyDetailViewComponent.MINIMUM_RANGE_END;
    } else {
      lineModel.max = tentativeMaxValueLine;
    }
    const rawMajorUnit = Math.floor(maxValueLine / 10);
    const majorUnitRoundedToNearestMinute = Math.ceil(rawMajorUnit / 60) * 60;
    lineModel.majorUnit =
      majorUnitRoundedToNearestMinute < 60
        ? 60
        : majorUnitRoundedToNearestMinute;
    lineModel.labels = {
      format: "n",
      content: function (e) {
        const minute = Math.floor(e.value / 60);
        return minute.toString().padStart(2, "0");
      },
    };
    this.commonData.avgTrafficWaitByHourValueAxis.push(lineModel);
    // Define categories
    this.commonData.avgTrafficWaitByHourCategories = _data.map((d) =>
      d.hourNumberAsNumber < 12
        ? d.hourNumberAsNumber.toString() + "am"
        : d.hourNumberAsNumber == 12
        ? "12pm"
        : (d.hourNumberAsNumber - 12).toString() + "pm"
    );
    // Define data series'
    if (!this.commonData.avgTrafficWaitByHourSeriesData) {
      this.commonData.avgTrafficWaitByHourSeriesData = new Array<any>();
    } else {
      this.commonData.avgTrafficWaitByHourSeriesData.length = 0;
    }
    var apptsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant(
        "_Report_Appointments_Completed_Ts_Text_"
      ),
      color: "#007BDB",
      axis: "Traffic",
      data: _data.map((m) => m.avgAppointmentsCompleted),
    };
    var walkInsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_WalkIn_Completed_Ts_Text_"),
      color: "#00A5DB",
      axis: "Traffic",
      data: _data.map((m) => m.avgWalkinsCompleted),
    };
    var abandonsSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_General_LWA_Text_"),
      color: "#7A45A1",
      axis: "Traffic",
      data: _data.map((m) => m.avgLWA),
    };
    var waitTimeSeries = {
      type: "line",
      stack: true,
      name: this.translateService.instant("_General_Report_Wait_Time_Text_"),
      color: "#7C91BC",
      axis: "Wait Time",
      //data: _data.map(m => ({ value: m.avgWaitTime/60, ValMinutes: Math.floor(m.avgWaitTime/60) ,  ValSeconds: formatNumber(m.avgWaitTime % 60, this.locale, "2.0-0")}))
      data: _data.map((m) => ({
        value: m.avgWaitTime,
        ValMinutes: Math.floor(m.avgWaitTime / 60),
        ValSeconds: formatNumber(m.avgWaitTime % 60, this.locale, "2.0-0"),
      })),
    };

    waitTimeSeries.data.forEach((x) => {
      // The ValMinutes field contains the no. of seconds for some unknown reason for just this graph
      x.ValMinutes = Math.floor(x.ValMinutes);
      x.ValSeconds = Math.floor(+x.ValSeconds).toString().padStart(2, "0");
    });

    this.commonData.avgTrafficWaitByHourSeriesData.push(
      apptsCompletedSeries,
      walkInsCompletedSeries,
      abandonsSeries,
      waitTimeSeries
    );
    // Place Bars scale on left, line scale on right
    this.commonData.avgTrafficWaitByHourCrossingValues = new Array(
      0,
      this.commonData.avgTrafficWaitByHourCategories.length + 1
    );
    this.commonData.avgTrafficWaitByHourVisible = true;
  }

  public mapAvgTrafficAndWaitByMonthData(
    _data: LobbyDetailViewTrafficAndWaitByMonthResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.avgTrafficWaitByMonthSeriesData = new Array<any>();
      this.commonData.avgTrafficWaitByMonthVisible = false;
      return;
    }

    // Define value axes
    var maxValueBarsObj = _data.reduce((a, b) =>
      a.avgAppointmentsCompleted + a.avgLWA + a.avgWalkinsCompleted >
      b.avgAppointmentsCompleted + b.avgLWA + b.avgWalkinsCompleted
        ? a
        : b
    );
    var maxValueBars: number =
      maxValueBarsObj.avgAppointmentsCompleted +
      maxValueBarsObj.avgLWA +
      maxValueBarsObj.avgWalkinsCompleted +
      1;
    // if (maxValueBars < this.commonData.lobbyReportHeaderData.totalRecords) {
    //   maxValueBars = this.commonData.lobbyReportHeaderData.totalRecords;
    // }
    var minValueBars = 0;
    var maxValueLineObj = _data.reduce((a, b) =>
      a.avgWaitTime > b.avgWaitTime ? a : b
    );
    var maxValueLine: number = (maxValueLineObj.avgWaitTime / 60) * 1.1;
    if (maxValueLine < 5) {
      maxValueLine = 5;
    }
    var minValueLine = 0;
    if (!this.commonData.avgTrafficWaitByMonthValueAxis) {
      this.commonData.avgTrafficWaitByMonthValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.avgTrafficWaitByMonthValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    barsModel.name = "Traffic";
    barsModel.title = this.translateService.instant("_Report_Traffic_Ts_Text_");
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars * 1.1);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    this.commonData.avgTrafficWaitByMonthValueAxis.push(barsModel);
    var lineModel = new ValueAxisModel();
    lineModel.name = "Wait Time";
    lineModel.title = this.translateService.instant(
      "_Report_Wait_Time_Minutes_Ts_Text_"
    );
    lineModel.min = minValueLine;
    //lineModel.max = Math.ceil(maxValueLine * 1.1);
    lineModel.max = Math.ceil(maxValueLine);
    //lineModel.majorUnit = Math.floor(maxValueLine / 11);
    lineModel.majorUnit = Math.ceil(maxValueLine / 10);
    lineModel.labels = {
      format: "n",
      content: function (e) {
        const minute = Math.floor(e.value);
        return minute.toString().padStart(2, "0");
      },
    };
    this.commonData.avgTrafficWaitByMonthValueAxis.push(lineModel);
    // Define categories
    this.commonData.avgTrafficWaitByMonthCategories = _data.map(
      (d) => d.monthName
    );
    // Define data series'
    if (!this.commonData.avgTrafficWaitByMonthSeriesData) {
      this.commonData.avgTrafficWaitByMonthSeriesData = new Array<any>();
    } else {
      this.commonData.avgTrafficWaitByMonthSeriesData.length = 0;
    }
    var apptsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant(
        "_Report_Appointments_Completed_Ts_Text_"
      ),
      color: "#007BDB",
      axis: "Traffic",
      data: _data.map((m) => m.avgAppointmentsCompleted),
    };
    var walkInsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_WalkIn_Completed_Ts_Text_"),
      color: "#00A5DB",
      axis: "Traffic",
      data: _data.map((m) => m.avgWalkinsCompleted),
    };
    var abandonsSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_General_LWA_Text_"),
      color: "#7A45A1",
      axis: "Traffic",
      data: _data.map((m) => m.avgLWA),
    };
    var waitTimeSeries = {
      type: "line",
      stack: true,
      name: this.translateService.instant("_General_Report_Wait_Time_Text_"),
      color: "#7C91BC",
      axis: "Wait Time",
      data: _data.map((m) => ({
        value: m.avgWaitTime / 60,
        ValMinutes: Math.floor(m.avgWaitTime / 60),
        ValSeconds: formatNumber(m.avgWaitTime % 60, this.locale, "2.0-0"),
      })),
    };
    this.commonData.avgTrafficWaitByMonthSeriesData.push(
      apptsCompletedSeries,
      walkInsCompletedSeries,
      abandonsSeries,
      waitTimeSeries
    );
    // Place Bars scale on left, line scale on right
    this.commonData.avgTrafficWaitByMonthCrossingValues = new Array(
      0,
      this.commonData.avgTrafficWaitByMonthCategories.length + 1
    );
    this.commonData.avgTrafficWaitByMonthVisible = true;
  }

  // **************************************************************************************************
  // Location Comparison View
  // **************************************************************************************************
  public mapTrafficAndWaitByLocationData(
    _data: LobbyDetailViewTrafficAndWaitByLocationResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.trafficAndWaitByLocationSeriesData = new Array<any>();
      this.commonData.trafficAndWaitByLocationVisible = false;
      return;
    }
    // Define value axes
    var maxValueBarsObj = _data.reduce((a, b) =>
      a.totalAppointmentsCompleted + a.totalLWA + a.totalWalkinsCompleted >
      b.totalAppointmentsCompleted + b.totalLWA + b.totalWalkinsCompleted
        ? a
        : b
    );
    var maxValueBars: number =
      maxValueBarsObj.totalAppointmentsCompleted +
      maxValueBarsObj.totalLWA +
      maxValueBarsObj.totalWalkinsCompleted +
      1;
    // if (maxValueBars < this.commonData.lobbyReportHeaderData.totalRecords) {
    //   maxValueBars = this.commonData.lobbyReportHeaderData.totalRecords;
    // }
    var minValueBars = 0;
    var maxValueLineObj = _data.reduce((a, b) =>
      a.avgWaitTime > b.avgWaitTime ? a : b
    );
    var maxValueLine: number = (maxValueLineObj.avgWaitTime / 60) * 1.1;
    if (maxValueLine < 5) {
      maxValueLine = 5;
    }
    var minValueLine = 0;
    if (!this.commonData.trafficAndWaitByLocationValueAxis) {
      this.commonData.trafficAndWaitByLocationValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.trafficAndWaitByLocationValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    barsModel.name = "Traffic";
    barsModel.title = this.translateService.instant("_Report_Traffic_Ts_Text_");
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars * 1.1);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    barsModel.labels = { format: "n" };
    this.commonData.trafficAndWaitByLocationValueAxis.push(barsModel);
    var lineModel = new ValueAxisModel();
    lineModel.name = "Wait Time";
    lineModel.title = this.translateService.instant(
      "_Report_Wait_Time_Minutes_Ts_Text_"
    );
    lineModel.min = minValueLine;

    const tentativeMaxValueLine = Math.ceil(maxValueLine) * 60;
    if (tentativeMaxValueLine < LobbyDetailViewComponent.MINIMUM_RANGE_END) {
      lineModel.max = LobbyDetailViewComponent.MINIMUM_RANGE_END;
    } else {
      lineModel.max = tentativeMaxValueLine;
    }
    const rawMajorUnit = Math.ceil(maxValueLine / 10);
    const majorUnitRoundedToNearestMinute = rawMajorUnit * 60;
    lineModel.majorUnit =
      majorUnitRoundedToNearestMinute < 60
        ? 60
        : majorUnitRoundedToNearestMinute;
    lineModel.labels = {
      format: "n",
      content: function (e) {
        const minute = Math.floor(e.value / 60);
        return minute.toString().padStart(2, "0");
      },
    };
    this.commonData.trafficAndWaitByLocationValueAxis.push(lineModel);
    // Define categories
    this.commonData.trafficAndWaitByLocationCategories = _data.map(
      (d) => d.locationName
    );
    // Define data series'
    if (!this.commonData.trafficAndWaitByLocationSeriesData) {
      this.commonData.trafficAndWaitByLocationSeriesData = new Array<any>();
    } else {
      this.commonData.trafficAndWaitByLocationSeriesData.length = 0;
    }
    var apptsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant(
        "_Report_Appointments_Completed_Ts_Text_"
      ),
      color: "#007BDB",
      axis: "Traffic",
      data: _data.map((m) => m.totalAppointmentsCompleted),
    };
    var walkInsCompletedSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_WalkIn_Completed_Ts_Text_"),
      color: "#00A5DB",
      axis: "Traffic",
      data: _data.map((m) => m.totalWalkinsCompleted),
    };
    var abandonsSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_General_LWA_Text_"),
      color: "#7A45A1",
      axis: "Traffic",
      data: _data.map((m) => m.totalLWA),
    };
    var waitTimeSeries = {
      type: "line",
      stack: true,
      name: this.translateService.instant("_General_Report_Wait_Time_Text_"),
      color: "#7C91BC",
      axis: "Wait Time",
      data: _data.map((m) => ({
        value: m.avgWaitTime,
        ValMinutes: Math.floor(m.avgWaitTime / 60),
        ValSeconds: formatNumber(m.avgWaitTime % 60, this.locale, "2.0-0"),
      })),
    };
    this.commonData.trafficAndWaitByLocationSeriesData.push(
      apptsCompletedSeries,
      walkInsCompletedSeries,
      abandonsSeries,
      waitTimeSeries
    );
    // Place Bars scale on left, line scale on right
    this.commonData.trafficAndWaitByLocationCrossingValues = new Array(
      0,
      this.commonData.trafficAndWaitByLocationCategories.length + 1
    );
    this.commonData.trafficAndWaitByLocationVisible = true;
  }

  public mapProductsAndServicesByLocationData(
    _data: LobbyDetailViewProductsAndServicesByLocationResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.productsAndServicesByLocationSeriesData =
        new Array<any>();
      this.commonData.productsAndServicesByLocationVisible = false;
      return;
    }

    // Define value axes
    var maxValueBarsObj = _data.reduce((a, b) =>
      a.totalProvided > b.totalProvided ? a : b
    );
    var maxValueBars: number = maxValueBarsObj.totalProvided + 1;
    if (!this.commonData.productsAndServicesByLocationValueAxis) {
      this.commonData.productsAndServicesByLocationValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.productsAndServicesByLocationValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    var minValueBars = 0;
    barsModel.name = "Products and Services";
    barsModel.title = this.translateService.instant("_Report_Count_Ts_Text_");
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars * 1.1);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    this.commonData.productsAndServicesByLocationValueAxis.push(barsModel);
    // Define categories
    this.commonData.productsAndServicesByLocationCategories = [
      ...new Set(_data.map((d) => d.locationName)),
    ];
    // Define data series'
    if (!this.commonData.productsAndServicesByLocationSeriesData) {
      this.commonData.productsAndServicesByLocationSeriesData =
        new Array<any>();
    } else {
      this.commonData.productsAndServicesByLocationSeriesData.length = 0;
    }
    var productsSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: false,
      name: this.translateService.instant("_Report_Lobby_Products_Text_"),
      color: "#007BDB",
      axis: "Products and Services",
      data: _data
        .filter((m1) => m1.productOrServiceType == "Product")
        .map((m) => m.totalProvided),
    };
    var servicesSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: false,
      name: this.translateService.instant("_Report_Lobby_Services_Text_"),
      color: "#54BBBA",
      axis: "Products and Services",
      data: _data
        .filter((m1) => m1.productOrServiceType == "Service")
        .map((m) => m.totalProvided),
    };
    var othersSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: false,
      name: this.translateService.instant("_Report_Filters_Other_Text_"),
      color: "#404756",
      axis: "Products and Services",
      data: _data
        .filter((m1) => m1.productOrServiceType == "Other")
        .map((m) => m.totalProvided),
    };
    this.commonData.productsAndServicesByLocationSeriesData.push(
      productsSeries,
      servicesSeries,
      othersSeries
    );
    this.commonData.productsAndServicesByLocationVisible = true;
  }

  public mapAvgAssistTimeByLocationData(
    _data: LobbyDetailViewAvgAssistTimeByLocationResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.avgAssistTimeByLocationSeriesData = new Array<any>();
      this.commonData.avgAssistTimeByLocationVisible = false;
      return;
    }
    this.seriesCenters = [];
    this.counter = 0;
    // Define value axes
    var maxValueBarsObj1 = _data.reduce((a, b) =>
      a.avgAssistTime > b.avgAssistTime ? a : b
    );
    var maxValueBarsObj2 = _data.reduce((a, b) =>
      a.avgTimeStandard > b.avgTimeStandard ? a : b
    );
    var maxValueBars: number =
      maxValueBarsObj1.avgAssistTime / 60 > maxValueBarsObj2.avgTimeStandard
        ? (maxValueBarsObj1.avgAssistTime / 60 + 1) * 1.1
        : (maxValueBarsObj2.avgTimeStandard + 1) * 1.1;

    var barsModel = new ValueAxisModel();
    var minValueBars = 0;
    barsModel.name = "Assist Time By Location";
    barsModel.title = this.translateService.instant(
      "_Report_Time_Minutes_Ts_Text_"
    );
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars);

    if (!this.commonData.avgAssistTimeByLocationValueAxis) {
      this.commonData.avgAssistTimeByLocationValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.avgAssistTimeByLocationValueAxis.length = 0;
    }
    this.commonData.avgAssistTimeByLocationValueAxis.push(barsModel);
    // Define categories
    this.commonData.avgAssistTimeByLocationCategories = [
      ...new Set(_data.map((d) => d.locationName)),
    ];
    var categoryAxis = new CategoryAxisModel();
    categoryAxis.name = "Assist Time By Location";
    categoryAxis.min = this.commonData.firstCategoryIndex;
    categoryAxis.max = this.commonData.lastCategoryIndex;
    categoryAxis.categories = this.commonData.avgAssistTimeByLocationCategories;

    var mappedData = _data.map((m) => ({
      avgAssistTime: m.avgAssistTime / 60,
      ValMinutes: Math.floor(m.avgAssistTime / 60),
      ValSeconds: formatNumber(m.avgAssistTime % 60, "en-US", "2.0"),
      StdMinutes: m.avgTimeStandard,
      locationName: m.locationName,
      productOrServiceType:
        m.productOrServiceType == "Product"
          ? "_Report_Lobby_Products_Text_"
          : m.productOrServiceType == "Service"
          ? "_Report_Lobby_Services_Text_"
          : "_Report_Filters_Other_Text_",
      color:
        m.productOrServiceType == "Product"
          ? "#007BDB"
          : m.productOrServiceType == "Service"
          ? "#54BBBA"
          : "#404756",
      sortIndex:
        m.productOrServiceType == "Product"
          ? 1
          : m.productOrServiceType == "Service"
          ? 2
          : 3,
    }));
    this.commonData.mappedLocationsAssistSeries = groupBy(
      mappedData.sort((a, b) => a.sortIndex - b.sortIndex),
      [{ field: "productOrServiceType" }]
    ) as GroupResult[];
    // Define data series'
    this.commonData.avgAssistTimeByLocationVisible = true;
  }

  public secondsToMinutesAndSecondsString(sec: number) {
    let minutes = Math.floor(sec / 60);
    let seconds = sec % 60;
    return minutes + ":" + seconds;
  }
  // **************************************************************************************************
  // Employee View
  // **************************************************************************************************

  public getEmployeeNameByCode(userList: any[], source: any[]): any[] {
    var employeeNameArray = new Array<any>();
    userList.forEach((userCode) => {
      var employeeName = source.find((s) => s.code == userCode)?.employeeName;
      employeeNameArray.push(employeeName);
    });
    return employeeNameArray;
  }
  public mapProductsAndServicesByEmployeeData(
    _data: LobbyDetailViewProductsAndServicesByEmployeeResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.productsAndServicesByEmployeeSeriesData =
        new Array<any>();
      this.commonData.productsAndServicesByEmployeeVisible = false;
      return;
    }
    // Define value axes
    var maxValueBarsObj = _.maxBy(
      _data.reduce((acc, curr) => {
        const found = acc.find((a) => a.code === curr.code);
        if (found) {
          found.totalProvided += curr.totalProvided;
        } else {
          acc.push({ code: curr.code, totalProvided: curr.totalProvided });
        }
        return acc;
      }, [] as { code: string; totalProvided: number }[]),
      "totalProvided"
    );
    var maxValueBars: number = (maxValueBarsObj?.totalProvided ?? 0) + 1;
    if (!this.commonData.productsAndServicesByEmployeeValueAxis) {
      this.commonData.productsAndServicesByEmployeeValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.productsAndServicesByEmployeeValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    var minValueBars = 0;
    barsModel.name = "Products and Services";
    barsModel.title = this.translateService.instant("_Report_Count_Ts_Text_");
    barsModel.min = minValueBars;
    // Keep extra headroom so total labels render above stacks.
    barsModel.max = Math.floor(maxValueBars * 1.3);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    this.commonData.productsAndServicesByEmployeeValueAxis.push(barsModel);
    // Build a stable per-employee matrix so all series align with categories.
    const employeeCodesInOrder = [...new Set(_data.map((d) => d.code))];
    const employeeByCode = new Map<
      string,
      {
        employeeName: string;
        product: { value: number; tooltip: string };
        service: { value: number; tooltip: string };
        other: { value: number; tooltip: string };
      }
    >();

    for (const code of employeeCodesInOrder) {
      const employeeName =
        _data.find((row) => row.code === code)?.employeeName ?? code;
      employeeByCode.set(code, {
        employeeName,
        product: {
          value: 0,
          tooltip: `${this.translateService.instant("_Report_Lobby_Products_Text_")}: 0`,
        },
        service: {
          value: 0,
          tooltip: `${this.translateService.instant("_Report_Lobby_Services_Text_")}: 0`,
        },
        other: {
          value: 0,
          tooltip: `${this.translateService.instant("_Report_Filters_Other_Text_")}: 0`,
        },
      });
    }

    for (const row of _data) {
      const employee = employeeByCode.get(row.code);
      if (!employee) {
        continue;
      }

      const normalizedType = (row.productOrServiceType || "")
        .trim()
        .toLowerCase();
      const hasVolume = row.totalProvided > 0;

      if (!hasVolume && (normalizedType.includes("unknown") || !normalizedType)) {
        continue;
      }

      if (normalizedType.includes("product")) {
        employee.product = {
          value: employee.product.value + row.totalProvided,
          tooltip: employee.product.tooltip,
        };
      } else if (normalizedType.includes("service")) {
        employee.service = {
          value: employee.service.value + row.totalProvided,
          tooltip: employee.service.tooltip,
        };
      } else {
        employee.other = {
          value: employee.other.value + row.totalProvided,
          tooltip: employee.other.tooltip,
        };
      }
    }

    employeeByCode.forEach((employee) => {
      const total =
        employee.product.value + employee.service.value + employee.other.value;

      const formatTooltip = (label: string, value: number) => {
        if (total <= 0) {
          return `${label}: ${value}`;
        }

        const percent = formatNumber((value / total) * 100, this.locale, "1.1-1");
        return `${label}: ${value} (${percent}%)`;
      };

      employee.product.tooltip = formatTooltip(
        this.translateService.instant("_Report_Lobby_Products_Text_"),
        employee.product.value
      );
      employee.service.tooltip = formatTooltip(
        this.translateService.instant("_Report_Lobby_Services_Text_"),
        employee.service.value
      );
      employee.other.tooltip = formatTooltip(
        this.translateService.instant("_Report_Filters_Other_Text_"),
        employee.other.value
      );
    });

    this.commonData.productsAndServicesByEmployeeCategories = employeeCodesInOrder.map(
      (code) => employeeByCode.get(code)?.employeeName ?? code
    );

    // Define data series'
    if (!this.commonData.productsAndServicesByEmployeeSeriesData) {
      this.commonData.productsAndServicesByEmployeeSeriesData =
        new Array<any>();
    } else {
      this.commonData.productsAndServicesByEmployeeSeriesData.length = 0;
    }
    var productsSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: true,
      name: this.translateService.instant("_Report_Lobby_Products_Text_"),
      color: this.seriesColors.Products,
      axis: "Products and Services",
      data: employeeCodesInOrder.map((code) => {
        const item = employeeByCode.get(code)!;
        return {
          value: item.product.value,
          tooltip: item.product.tooltip,
          color: this.seriesColors.Products,
        };
      }),
    };
    var servicesSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: true,
      name: this.translateService.instant("_Report_Lobby_Services_Text_"),
      color: this.seriesColors.Services,
      axis: "Products and Services",
      data: employeeCodesInOrder.map((code) => {
        const item = employeeByCode.get(code)!;
        return {
          value: item.service.value,
          tooltip: item.service.tooltip,
          color: this.seriesColors.Services,
        };
      }),
    };
    var otherSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: true,
      name: this.translateService.instant("_Report_Filters_Other_Text_"),
      color: this.seriesColors.Other,
      axis: "Products and Services",
      data: employeeCodesInOrder.map((code) => {
        const item = employeeByCode.get(code)!;
        return {
          value: item.other.value,
          tooltip: item.other.tooltip,
          color: this.seriesColors.Other,
        };
      }),
    };
    var totalSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: true,
      name: "__total__",
      color: "transparent",
      axis: "Products and Services",
      data: employeeCodesInOrder.map(() => ({
        value: 0,
      })),
    };
    this.commonData.productsAndServicesByEmployeeSeriesData.push(
      productsSeries,
      servicesSeries,
      otherSeries,
      totalSeries
    );
    this.commonData.productsAndServicesByEmployeeVisible = true;
  }

  public setTotal = (args: SeriesLabelsContentArgs) => {
    const total = args.stackValue;
    if (total === null || total === undefined) {
      return "";
    }
    if (Number(total) === 0) {
      return "";
    }
    return total.toString();
  };

  public setTotalVisual = (args: SeriesLabelsVisualArgs): KendoText => {
    const text = new KendoText(args.text, new geometry.Point(0, 0), {
      font: "600 12px Arial",
      fill: { color: "#424242", opacity: 1 },
    });
    const textBox = text.bbox();
    const x = args.rect.center().x - textBox.size.width / 2;
    const y = args.rect.origin.y - 18;
    text.position(new geometry.Point(x, y));
    return text;
  };

  public mapAvgAssistTimeByEmployeeData(
    _data: LobbyDetailViewAvgAssistTimeByEmployeeResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.avgAssistTimeByEmployeeSeriesData = new Array<any>();
      this.commonData.avgAssistTimeByEmployeeVisible = false;
      return;
    }
    this.seriesCenters = [];
    this.counter = 0;
    // Define value axes
    var maxValueBarsObj1 = _data.reduce((a, b) =>
      a.avgAssistTime > b.avgAssistTime ? a : b
    );
    var maxValueBarsObj2 = _data.reduce((a, b) =>
      a.avgTimeStandard > b.avgTimeStandard ? a : b
    );
    var maxValueBars: number =
      maxValueBarsObj1.avgAssistTime / 60 > maxValueBarsObj2.avgTimeStandard
        ? (maxValueBarsObj1.avgAssistTime / 60 + 1) * 1.1
        : (maxValueBarsObj2.avgTimeStandard + 1) * 1.1;

    var barsModel = new ValueAxisModel();
    var minValueBars = 0;
    barsModel.name = "Assist Time By Employee";
    barsModel.title = this.translateService.instant(
      "_Report_Time_Minutes_Ts_Text_"
    );
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);

    if (!this.commonData.avgAssistTimeByEmployeeValueAxis) {
      this.commonData.avgAssistTimeByEmployeeValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.avgAssistTimeByEmployeeValueAxis.length = 0;
    }
    this.commonData.avgAssistTimeByEmployeeValueAxis.push(barsModel);
    // Define categories

    var uniqueEmployeeListByCode = [...new Set(_data.map((d) => d.code))];

    this.commonData.avgAssistTimeByEmployeeCategories =
      this.getEmployeeNameByCode(uniqueEmployeeListByCode, _data);
    var categoryAxis = new CategoryAxisModel();
    categoryAxis.name = "Assist Time By Employee";
    categoryAxis.min = this.commonData.firstCategoryIndex;
    categoryAxis.max = this.commonData.lastCategoryIndex;
    categoryAxis.categories = this.commonData.avgAssistTimeByEmployeeCategories;

    var mappedData = _data.map((m) => ({
      avgAssistTime: m.avgAssistTime / 60,
      ValMinutes: Math.floor(m.avgAssistTime / 60),
      ValSeconds: formatNumber(m.avgAssistTime % 60, "en-US", "2.0"),
      StdMinutes: m.avgTimeStandard,
      employeeName: m.employeeName,
      productOrServiceType:
        m.productOrServiceType == "Product"
          ? "Products"
          : m.productOrServiceType == "Service"
          ? "Services"
          : "Other",
      color:
        m.productOrServiceType == "Product"
          ? "#007BDB"
          : m.productOrServiceType == "Service"
          ? "#54BBBA"
          : "#404756",
      sortIndex:
        m.productOrServiceType == "Product"
          ? 1
          : m.productOrServiceType == "Service"
          ? 2
          : 3,
    }));
    this.commonData.mappedEmployeeAssistSeries = groupBy(
      mappedData.sort((a, b) => a.sortIndex - b.sortIndex),
      [{ field: "productOrServiceType" }]
    ) as GroupResult[];
    // Define data series'
    this.commonData.avgAssistTimeByEmployeeVisible = true;
  }

  // **************************************************************************************************
  // Products and Services View
  // **************************************************************************************************
  public mapProductsAndServicesProvidedData(
    _data: LobbyDetailViewProductsAndServicesProvidedResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.productsAndServicesProvidedSeriesData = new Array<any>();
      this.commonData.productsAndServicesProvidedVisible = false;
      return;
    }
    // Define value axes
    var maxValueBarsObj;
    var maxValueBars: number;
    if (_data.length > 0) {
      maxValueBarsObj = _data.reduce((a, b) =>
        a.numberProvided > b.numberProvided ? a : b
      );
      maxValueBars = maxValueBarsObj.numberProvided + 1;
    } else {
      maxValueBars = 0;
    }
    if (!this.commonData.productsAndServicesProvidedValueAxis) {
      this.commonData.productsAndServicesProvidedValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.productsAndServicesProvidedValueAxis.length = 0;
    }
    var barsModel = new ValueAxisModel();
    var minValueBars = 0;
    barsModel.name = "Products and Services";
    barsModel.title = this.translateService.instant("_Report_Count_Ts_Text_");
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars * 1.1);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);
    this.commonData.productsAndServicesProvidedValueAxis.push(barsModel);
    this.commonData.productsAndServicesProvidedCategories = [
      ...new Set(_data.map((d) => d.productServiceName)),
    ];

    // This chart is a special case. We want a classic 'column' chart, but with comingled data series'. This is not supported by the Kendo charting library.
    // But we can fake it by constructing a 'stacked' chart and making the data from whichever category is NOT represented by the data point type a '0'.
    // Just have to make sure we construct equal numbers of series data points in EACH series as there are total categories. Then a little
    // sorting and correlation work and we're done.
    var serviceSeriesData = new Array(_data.length);
    var productSeriesData = new Array(_data.length);
    var otherSeriesData = new Array(_data.length);
    _data.forEach((d) => {
      var idx = this.commonData.productsAndServicesProvidedCategories.indexOf(
        d.productServiceName
      );
      productSeriesData[idx] = 0;
      serviceSeriesData[idx] = 0;
      otherSeriesData[idx] = 0;
      if (d.productOrServiceType == "Service") {
        serviceSeriesData[idx] = d.numberProvided;
      } else if (d.productOrServiceType == "Product") {
        productSeriesData[idx] = d.numberProvided;
      } else {
        otherSeriesData[idx] = d.numberProvided;
      }
    });
    // Define data series'
    if (!this.commonData.productsAndServicesProvidedSeriesData) {
      this.commonData.productsAndServicesProvidedSeriesData = new Array<any>();
    } else {
      this.commonData.productsAndServicesProvidedSeriesData.length = 0;
    }
    var productsSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_Lobby_Products_Text_"),
      color: "#007BDB",
      axis: "Products and Services",
      data: productSeriesData,
    };
    var servicesSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_Lobby_Services_Text_"),
      color: "#54BBBA",
      axis: "Products and Services",
      data: serviceSeriesData,
    };
    var otherSeries = {
      type: "column",
      stack: true,
      name: this.translateService.instant("_Report_Filters_Other_Text_"),
      color: "#404756",
      axis: "Products and Services",
      data: otherSeriesData,
    };

    this.commonData.productsAndServicesProvidedSeriesData.push(
      productsSeries,
      servicesSeries,
      otherSeries
    );
    this.commonData.productsAndServicesProvidedVisible = true;
  }

  public mapAvgAssistTimeByProductOrServiceData(
    _data: LobbyDetailViewAvgAssistTimeByProductOrServiceResponseModel[]
  ) {
    if (_data == null) {
      this.commonData.avgAssistTimeByProductOrServiceSeriesData =
        new Array<any>();
      this.commonData.avgAssistTimeByProductOrServiceVisible = false;
      return;
    }
    // Define value axes
    var maxValueBarsObj1;
    var maxValueBarsObj2;
    var maxValueBars: number = 0;
    if (_data.length > 0) {
      maxValueBarsObj1 = _data.reduce((a, b) =>
        a.avgAssistTime > b.avgAssistTime ? a : b
      );
      maxValueBarsObj2 = _data.reduce((a, b) =>
        a.avgTimeStandard > b.avgTimeStandard ? a : b
      );
      maxValueBars =
        maxValueBarsObj1.avgAssistTime / 60 > maxValueBarsObj2.avgTimeStandard
          ? (maxValueBarsObj1.avgAssistTime / 60 + 1) * 1.1
          : (maxValueBarsObj2.avgTimeStandard + 1) * 1.1;
    }

    var barsModel = new ValueAxisModel();
    var minValueBars = 0;
    barsModel.name = "Assist Time Products and Services";
    barsModel.title = this.translateService.instant(
      "_Report_Time_Minutes_Ts_Text_"
    );
    barsModel.min = minValueBars;
    barsModel.max = Math.floor(maxValueBars);
    barsModel.majorUnit = Math.ceil(maxValueBars / 11);

    if (!this.commonData.avgAssistTimeByProductOrServiceValueAxis) {
      this.commonData.avgAssistTimeByProductOrServiceValueAxis =
        new Array<ValueAxisModel>();
    } else {
      this.commonData.avgAssistTimeByProductOrServiceValueAxis.length = 0;
    }
    this.commonData.avgAssistTimeByProductOrServiceValueAxis.push(barsModel);
    // Define categories
    this.commonData.avgAssistTimeByProductOrServiceCategories = [
      ...new Set(_data.map((d) => d.productServiceName)),
    ];

    var serviceSeriesData = new Array(_data.length);
    var productSeriesData = new Array(_data.length);
    var otherSeriesData = new Array(_data.length);
    var timeStandardSeriesData = new Array(_data.length);
    _data.forEach((d) => {
      try {
        var idx =
          this.commonData.avgAssistTimeByProductOrServiceCategories.indexOf(
            d.productServiceName
          );
        productSeriesData[idx] = 0;
        serviceSeriesData[idx] = 0;
        otherSeriesData[idx] = 0;
        timeStandardSeriesData[idx] = d.avgTimeStandard;
        if (d.productOrServiceType == "Service") {
          serviceSeriesData[idx] = {
            value: d.avgAssistTime / 60,
            ValMinutes: Math.floor(d.avgAssistTime / 60),
            ValSeconds: formatNumber(d.avgAssistTime % 60, this.locale, "2.0"),
          };
        } else if (d.productOrServiceType == "Product") {
          productSeriesData[idx] = {
            value: d.avgAssistTime / 60,
            ValMinutes: Math.floor(d.avgAssistTime / 60),
            ValSeconds: formatNumber(d.avgAssistTime % 60, this.locale, "2.0"),
          };
        } else {
          otherSeriesData[idx] = {
            value: d.avgAssistTime / 60,
            ValMinutes: Math.floor(d.avgAssistTime / 60),
            ValSeconds: formatNumber(d.avgAssistTime % 60, this.locale, "2.0"),
          };
        }
      } catch (e) {
        var error = e;
      }
    });

    // Define data series'
    if (!this.commonData.avgAssistTimeByProductOrServiceSeriesData) {
      this.commonData.avgAssistTimeByProductOrServiceSeriesData =
        new Array<any>();
    } else {
      this.commonData.avgAssistTimeByProductOrServiceSeriesData.length = 0;
    }
    var productsSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: false,
      name:
        this.translateService.instant("_General_Report_Assist_Time_Text_") +
        " - " +
        this.translateService.instant("_Report_Lobby_Products_Text_"),
      color: "#007BDB",
      axis: "Assist Time Products and Services",
      data: productSeriesData,
    };
    var servicesSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: false,
      name:
        this.translateService.instant("_General_Report_Assist_Time_Text_") +
        " - " +
        this.translateService.instant("_Report_Lobby_Services_Text_"),
      color: "#54BBBA",
      axis: "Assist Time Products and Services",
      data: serviceSeriesData,
    };
    var othersSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: false,
      name:
        this.translateService.instant("_General_Report_Assist_Time_Text_") +
        " - " +
        this.translateService.instant("_Report_Filters_Other_Text_"),
      color: "#404756",
      axis: "Assist Time Products and Services",
      data: otherSeriesData,
    };
    var timeStandardSeries = {
      type: "column",
      gap: 2,
      spacing: 0.25,
      stack: false,
      name: this.translateService.instant("_General_Time_Standard_Text_"),
      color: "#7C91BC",
      axis: "Assist Time Products and Services",
      data: timeStandardSeriesData,
    };
    this.commonData.avgAssistTimeByProductOrServiceSeriesData.push(
      productsSeries,
      timeStandardSeries,
      servicesSeries,
      othersSeries
    );
    this.commonData.avgAssistTimeByProductOrServiceVisible = true;
  }

  // ***************************************************************************************
  // Specific to Employee View and Location Comparison Views Avg Assist Times Charts
  // ***************************************************************************************

  // In the Avg Assist Times charts for Location View and Employee View, we had
  // to do some special coding tomake the Time Standard circles display as required.
  // This was done in the second of the two kendo-chart-series-item elements in the data series elements of
  // the two affected charts.
  // One side effect of this was that the legend colors got disconnected such that the line indicator on
  // each legend item no longer reflected the color of the related data series.
  // to fix this, it was necessary to create customized legend items by handling the
  // [visuals] event which is bound to legendVisuals below, creating and returning anew visuals object that
  // displays the legend item like the rest ofthe charts.
  seriesVisuals(args: SeriesVisualArgs) {
    this.seriesCenters.push(args.rect.center());
    return args.createVisual();
  }
  yaxisVisual(e: AxisLabelVisualArgs): KendoText {
    const text = new KendoText(e.text, e.rect.origin, {
      font: `bold 15px Arial`,
    });
    return text;
  }

  visual(args: SeriesVisualArgs) {
    let circleShape: CircleShape;
    let rectCenter: Point = args.rect.center();

    circleShape = new CircleShape(
      new Point(this.seriesCenters[this.counter].x, rectCenter.y),
      5
    );

    let options: ShapeOptions = {
      stroke: { color: "black", width: 1 },
      fill: { color: "yellow" },
    };

    let circle = new Circle(circleShape, options);
    this.counter++;

    return circle;
  }

  public legendVisuals(e: LegendItemVisualArgs): Group {
    const group = new Group();
    const { Point } = geometry;
    const color = e.series.color
      ? e.series.color
      : e.series.data[0]?.color;
    const path = new Path({
      stroke: {
        color: color,
        width: 0,
      },
      fill: { opacity: 1, color: color },
    });

    path.moveTo(38, 35).lineTo(54, 35).lineTo(54, 38).lineTo(38, 38).close();

    const text = new KendoText(e.series.name, new Point(60, 25), {
      font: "font:400 11.998px poppins, 'Open Sans', roboto, sans-serif;white-space:pre;",
      fill: { opacity: 1, color: "rgb(66,66,66)" },
    });

    group.append(text, path);

    return group;
  }

  public legendVisuals_AssistTime = (e: LegendItemVisualArgs): Group => {
    const group = new Group();
    const { Point } = geometry;
    const color = e.series.data[0].color
      ? e.series.data[0].color
      : e.series.color;
    const path = new Path({
      stroke: {
        color: color,
        width: 0,
      },
      fill: { opacity: 1, color: color },
    });

    path.moveTo(38, 35).lineTo(54, 35).lineTo(54, 38).lineTo(38, 38).close();

    const text = new KendoText(
      this.translateService.instant("_General_Report_Assist_Time_Text_") +
        " - " +
        this.translateService.instant(e.series.name),
      new Point(60, 25),
      {
        font: "font:400 11.998px poppins, 'Open Sans', roboto, sans-serif;white-space:pre;",
        fill: { opacity: 1, color: "rgb(66,66,66)" },
      }
    );

    group.append(text, path);

    return group;
  };

  public seriesHover(e: any) {
    return e;
  }

  public allData = (): Observable<any> => {
    var gridDataRequest = new LobbyDetailViewExportRequest(
      this.commonData.currentTemplate,
      this.commonData.reportStartDate,
      this.commonData.reportEndDate,
      this.getSortInfo()
    );
    return this.reportService.getLobbyDetailViewExport(gridDataRequest);
  };

  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;

    if (this.filterText != "") this.runReport(false, true);
    else this.runReport(false);
  }

  public sortChange(sort: SortDescriptor[]) {
    if (!sort || sort.length === 0 || sort[0].dir == undefined) {
      this.sort = [...this.defaultSort];
    } else {
      this.sort = sort;
    }
    this.runReport(false);
  }

  public getSortInfo(): SortInfo {
    let field = this.sort[0].field;
    let dir = this.sort[0].dir === "asc" ? "asc" : "desc";

    if (field !== this.defaultSort[0].field) {
      dir = dir === "asc" ? "desc" : "asc";
    }
    if (field.length > 2) {
      let firstLetter = field.charAt(0).toUpperCase();
      field = firstLetter + field.substring(1);
    }
    return {
      SortColumn: field,
      sortDirection: dir === "asc" ? 1 : 2,
    };
  }
  public getPageInfo(): PageInfo {
    return { Page: this.skip / this.pageSize + 1, PageSize: this.pageSize };
  }

  public resetGridOptions() {
    this.skip = 0;
  }

  public exportToCsv(): any {
    var headers = [];
    headers.push([
      "Total Records",
      this.commonData.lobbyReportHeaderData.totalRecords,
    ]);
    headers.push(["No Show", this.commonData.lobbyReportHeaderData.noShows]);
    headers.push([
      "Appointment Completed",
      this.commonData.lobbyReportHeaderData.appointmentsCompleted,
    ]);
    headers.push([
      "Walk-In Completed",
      this.commonData.lobbyReportHeaderData.walkinsCompleted,
    ]);
    headers.push([
      "Left Without Assistance",
      this.commonData.lobbyReportHeaderData.abandons,
    ]);
    headers.push([
      "Left Without Assistance %",
      this.commonData.lobbyReportHeaderData.abandonsAsPercentOfTotalRecords,
    ]);
    headers.push([
      "Average Wait Time",
      this.commonData.lobbyReportHeaderData.avgWaitTimeFormatted,
    ]);
    headers.push([
      "Average Assist Time",
      this.commonData.lobbyReportHeaderData.avgAssistTimeFormatted,
    ]);

    var gridDataRequest = new LobbyDetailViewExportRequest(
      this.commonData.currentTemplate,
      this.commonData.reportStartDate,
      this.commonData.reportEndDate,
      this.getSortInfo(),
      headers
    );

    this.reportService
      .getLobbyDetailViewCsvExport(gridDataRequest)
      .subscribe((response) => {
        const contentDisposition =
          response.headers.get("Content-Disposition") ||
          response.headers.get("content-disposition");
        let filename = "LobbyDetailExport.csv";
        if (contentDisposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        const blob = new Blob([response.body], { type: "application/csv" });
        const downloadURL = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadURL;
        link.download = filename;
        link.click();
      });
  }

  public onExcelExport(e: any): void {
    const sheet = e.workbook.sheets[0];
    const filterT = this.commonData.currentTemplate;
    const reportStartDate = this.commonData.reportStartDate,
      reportEndDate = this.commonData.reportEndDate;

    sheet.rows.splice(0, 0, {
      cells: [{ value: "Lobby Activity Report" }],
      type: "data",
    });

    sheet.rows.splice(1, 0, {
      cells: [
        { value: "Filter:" },
        { value: filterT.templateName },
        { value: "StartDate:" },
        { value: reportStartDate },
        { value: "EndDate:" },
        { value: reportEndDate },
        { value: "Last Refreshed Date:" },
        { value: this.lastRefreshedString },
      ],
      type: "data",
    });

    sheet.rows.splice(2, 0, {
      cells: [
        { value: "Location:" },
        { value: this.getFilterValues(filterT, "location") },
        { value: "Day Of Week:" },
        { value: this.getFilterValues(filterT, "dayOfWeek") },
        { value: "Requested Staff:" },
        { value: this.getFilterValues(filterT, "requestedStaff") },
        { value: "Assisted By:" },
        { value: this.getFilterValues(filterT, "assistedBy") },
        { value: "Supervisor:" },
        { value: this.getFilterValues(filterT, "supervisor") },
      ],
      type: "data",
    });

    sheet.rows.splice(3, 0, {
      cells: [
        { value: "Category:" },
        { value: this.getFilterValues(filterT, "category") },
        { value: "Products & Services:" },
        { value: this.getFilterValues(filterT, "service") },
        { value: "Status:" },
        { value: this.getFilterValues(filterT, "status") },
        { value: "Assisted Type:" },
        { value: this.getFilterValues(filterT, "assisttype") },
        { value: "Search:" },
        { value: this.getFilterValues(filterT, "search") },
      ],
      type: "data",
    });

    sheet.rows.splice(4, 0, { cells: [], type: "data" });
    sheet.rows.splice(5, 0, {
      cells: [
        { value: "Total Records" },
        { value: this.commonData.lobbyReportHeaderData.totalRecords },
      ],
      type: "data",
    });
    sheet.rows.splice(6, 0, {
      cells: [
        { value: "No Show" },
        { value: this.commonData.lobbyReportHeaderData.noShows },
      ],
      type: "data",
    });
    sheet.rows.splice(7, 0, {
      cells: [
        { value: "Appointment Completed" },
        { value: this.commonData.lobbyReportHeaderData.appointmentsCompleted },
      ],
      type: "data",
    });
    sheet.rows.splice(8, 0, {
      cells: [
        { value: "Walk-In Completed" },
        { value: this.commonData.lobbyReportHeaderData.walkinsCompleted },
      ],
      type: "data",
    });
    sheet.rows.splice(9, 0, {
      cells: [
        { value: "Left Without Assistance" },
        { value: this.commonData.lobbyReportHeaderData.abandons },
      ],
      type: "data",
    });
    sheet.rows.splice(10, 0, {
      cells: [
        { value: "Left Without Assistance %" },
        {
          value:
            this.commonData.lobbyReportHeaderData
              .abandonsAsPercentOfTotalRecords,
        },
      ],
      type: "data",
    });
    sheet.rows.splice(11, 0, {
      cells: [
        { value: "Average Wait Time" },
        { value: this.commonData.lobbyReportHeaderData.avgWaitTimeFormatted },
      ],
      type: "data",
    });
    sheet.rows.splice(12, 0, {
      cells: [
        { value: "Average Assist Time" },
        { value: this.commonData.lobbyReportHeaderData.avgAssistTimeFormatted },
      ],
      type: "data",
    });
    sheet.rows.splice(13, 0, { cells: [], type: "data" });
  }

  public getFilterValues(
    filterTemplate: FilterTemplateResponseModel,
    name: string
  ): string {
    let result: string = "";
    name = name.toLowerCase();

    if (name == "location") {
      result = filterTemplate.allLocations
        ? "All"
        : filterTemplate.activeFilters.locations
            .map(function (value) {
              return value.locationName;
            })
            .join(",");
    } else if (name == "dayofweek") {
      result = filterTemplate.allDays
        ? "All"
        : filterTemplate.activeFilters.daysOfWeek
            .map(function (value) {
              return value.dayOfWeekName;
            })
            .join(",");
    } else if (name == "requestedstaff") {
      result = filterTemplate.allRequestedStaff
        ? "All"
        : filterTemplate.activeFilters.requestedStaff
            .map(function (value) {
              return value.staffFullname;
            })
            .join(",");
    } else if (name == "assistedby") {
      result = filterTemplate.allAssistedBy
        ? "All"
        : filterTemplate.activeFilters.assistedBy
            .map(function (value) {
              return value.staffFullname;
            })
            .join(",");
    } else if (name == "supervisor") {
      result = filterTemplate.allSupervisors
        ? "All"
        : filterTemplate.activeFilters.supervisors
            .map(function (value) {
              return value.staffFullname;
            })
            .join(",");
    } else if (name == "category") {
      result = filterTemplate.allCategories
        ? "All"
        : filterTemplate.activeFilters.categories
            .map(function (value) {
              return value.categoryName;
            })
            .join(",");
    } else if (name == "service") {
      result = filterTemplate.allServices
        ? "All"
        : filterTemplate.activeFilters.services
            .map(function (value) {
              return value.serviceName;
            })
            .join(",");
    } else if (name == "status") {
      result = filterTemplate.allStatuses
        ? "All"
        : filterTemplate.activeFilters.statuses
            .map(function (value) {
              return value.statusName;
            })
            .join(",");
    } else if (name == "assisttype") {
      result = filterTemplate.allAssistTypes
        ? "All"
        : filterTemplate.activeFilters.assistTypes
            .map(function (value) {
              return value.assistTypeName;
            })
            .join(",");
    } else if (name == "search") {
      result = filterTemplate.activeFilters.searchTerms
        .map(function (value) {
          return value.searchTerm;
        })
        .join(",");
    }

    return result;
  }

  //SignInOut Report Export
  public signInOutExportToCsv(): any {
    var gridDataRequest = new LobbyDetailViewExportRequest(
      this.commonData.currentTemplate,
      this.commonData.reportStartDate,
      this.commonData.reportEndDate,
      this.getSortInfo()
    );

    this.reportService
      .getStaffSignInOutLogCsvExportCsvExport(gridDataRequest)
      .subscribe((response) => {
        let blob = new Blob([response], { type: "application/csv" });
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        var filename = "SignInOutLogExport.csv";
        link.href = downloadURL;
        link.download = filename;
        link.click();
      });
  }

  /**
   *
   * @param Handles the grid paginations
   */
  public dataStateChange(state: DataStateChangeEvent): void {}

  public onDataStateChange(state: DataStateChangeEvent): void {}

  public doNothing() {}

  public exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }

  private collapseAllRows(): void {
    if (this.gridData && this.grid) {
      for (let x = 0; x < this.gridData.total; x++) {
        this.grid.collapseRow(x);
      }
    }
  }

  onClearSearchTextClicked() {
    if (this.filterText != "") {
      this.filterText = "";
      this.runReport();
    }
  }

  onFilterTextSearchClicked() {
    this.skip = 0;
    this.pageSize = 20;
    const searchText = this.filterText;
    this.loadGridData(searchText);
  }

  onFilterTextEnterKeyPress(e: any) {
    e.preventDefault();
    this.onFilterTextSearchClicked();
  }

  getSeriesColorBasedOnProductServiceType(seriesObject: any): string {
    return this.seriesColors[
      seriesObject.productOrServiceType as keyof typeof this.seriesColors
    ];
  }
}
